var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","text":"","icon":false}},[_c('div',{staticClass:"text-subtitle-2"},[_vm._v(" Rejected findings are only available when you are connected. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }